import React, { useEffect, useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import Lottie from "lottie-react";

/**
 * ⚠️ WarningAlert
 * Alerta de advertencia animada, completamente responsiva.
 */
const WarningAlert = ({
  isVisible,
  title,
  message,
}: {
  isVisible: boolean;
  title: string;
  message: string;
}) => {
  const { opacity } = useSpring({
    opacity: isVisible ? 1 : 0,
    config: { duration: 400 },
  });

  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    if (isVisible) {
      import("../../assets/animations/alerts/alerta-warning.json").then((mod) =>
        setAnimationData(mod.default)
      );
    } else {
      setAnimationData(null);
    }
  }, [isVisible]);

  return (
    <animated.div
      style={{
        opacity,
        pointerEvents: isVisible ? "auto" : "none",
      }}
      className="fixed inset-x-0 top-4 z-[9999] flex justify-center sm:justify-end px-4"
    >
      {isVisible && (
        <div className="flex w-full max-w-sm sm:max-w-md md:max-w-lg items-start rounded-xl border border-[#FFEB3B] bg-white dark:bg-boxdark p-3 sm:p-4 shadow-lg dark:border-[#FBC02D]">
          {/* 🔶 Animación */}
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center">
            {animationData && (
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ width: 55, height: 55 }}
              />
            )}
          </div>

          {/* 📄 Texto */}
          <div className="ml-3 flex flex-col overflow-hidden">
            <h4 className="text-sm font-semibold text-[#967930] dark:text-[#FBC02D] truncate sm:whitespace-normal">
              {title}
            </h4>
            <p className="text-sm font-medium text-[#967930] dark:text-[#FBC02D] leading-tight break-words whitespace-normal">
              {message}
            </p>
          </div>
        </div>
      )}
    </animated.div>
  );
};

export default React.memo(WarningAlert);
